import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { SecurityService } from '../../../services/security.service';

@Component({
  selector: 'app-buttons-gestione-utenti',
  templateUrl: './buttons-gestione-utenti.component.html',
  styleUrls: ['./buttons-gestione-utenti.component.css']
})
export class ButtonsGestioneUtentiComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() openDeleteModalEvent = new EventEmitter<any>();
  @Output() openUpdateModalEvent = new EventEmitter<any>();




  constructor(private securityService: SecurityService) { }

  ngOnInit() {
  }

  openDeleteModal() {
    this.openDeleteModalEvent.emit(this.rowData);

  }

  openUpdateModal() {
    this.openUpdateModalEvent.emit(this.rowData);
  }

  viewEdit(){
    let res:boolean = this.securityService.isUserAdmin() || (this.securityService.getUsername()==this.rowData.username);
    return res;
  }

  viewDelete(){
    let res:boolean = this.securityService.isUserAdmin() && (this.securityService.getUsername()!=this.rowData.username);
    return res;
  }



}
